import $ from "jquery";
import { csl, u_ } from "@pressmedia/webappbase";
const { app } = window;

export default {
	_keyChangeCount: 0,
	_keyChangeLimit: 10,
	
	/**
	 * 状態変化時のコールバック
	 * @param {Object} state
	 * @returns Promise
	 */
	async onChangeState(state) {
		const contentKey = app.currentPath.split("/").pop();
		const flg = {
			popstate: !!state.popstate,
			releaseWL: !!state.releaseWL,
			login: (contentKey === "login"),
			keyChanged: false,
			viewChanged: false,
			updList: false
		};
		
		csl.log.red("vuwer.changeState", state);
		delete state.popstate;
		delete state.releaseWL;
		
		// 認証エラーの場合のために引数で渡されたstateを保持しておく
		app.isWaitingLogin() || app.setWaitingState(state);
		
		// pageMainの高さを現状に固定
		const pageMain = this.get("pageMain");
		if(pageMain && app.isReady) {
			pageMain.$self.css( "min-height", pageMain.$self.outerHeight() );
		}
		
		
		// **** contentKey ****
		if( contentKey !== this.getContentKey() ) {
			// contentKeyが変更になった場合
			(app.isReady && !flg.login) && this._keyChangeCount++;
			
			if(this._keyChangeCount >= this._keyChangeLimit) {
				// 規定回数を超えた場合はリフレッシュする
				location.href = app.URL + u_.createQueryString(state);
				return false;
			}
			
			
			flg.keyChanged = true;
			
			if(app.nav) {
				// ログイン時はログアウトボタンを無効に
				flg.login && app.nav.$btnLogout.addClass("is-disable");
				
				// ナビゲーションのアクティブな部品の切り替え
				const activeMenu = flg.login ? "" : (contentKey || app.defaultViewOfApp);
				app.nav.get("menu").setActive(activeMenu);
			}
			
			// ローダー表示
			app.showLoading("key changed");
			
			// **** moduleのdataKeyが変更になった場合は一覧を更新する ****
			flg.updList = this.setContentKey(contentKey);
		}
		
		if(contentKey && !flg.login) {
			if(app.module.vuw) {
				// [sort]
				if(state.sort !== this.state.sort) {
					// sortが変更になった場合はページャーをリセット
					if( u_.hasProperty(state, app.module.vuw.pageQuery) ) {
						delete state[app.module.vuw.pageQuery];
					}
				} else
				
				// [{pageQuery}] 1の場合は削除
				if(
					u_.hasProperty(state, app.module.vuw.pageQuery) && (
						!state[app.module.vuw.pageQuery] || state[app.module.vuw.pageQuery] === "1"
					)
				) {
					delete state[app.module.vuw.pageQuery];
				}
			}
		} else {
			if( u_.hasProperty(state, "sort") ) {
				delete state.sort;
			}
			
			if(app.module.vuw) {
				if( u_.hasProperty(state, app.module.vuw.pageQuery) ) {
					delete state[app.module.vuw.pageQuery];
				}
			}
		}
		
		
		// **** view ****
		let view;
		
		// set default
		if(contentKey) {
			if(
				this.childSections.indexOf(contentKey) >= 0 &&
				("list_edit_preview").indexOf(contentKey) < 0
			) {
				view = contentKey;
				
			} else {
				if(app.defaultViewByContent[contentKey]) {
					view = app.defaultViewByContent[contentKey];
				} else
				if( app.module.getDataKey() ) {
					view = app.defaultViewByContent._def_;
				} else {
					view = "";
					app.alert("存在しないコンテンツです");
				}
			}
		} else {
			view = app.defaultViewOfApp;
		}
		
		// [v]
		if( u_.hasProperty(state, "v") ) {
			if(flg.login || !state.v || state.v === view) {
				delete state.v;
			} else {
				view = state.v;
			}
		}
		
		// ***** child vuw's state ****
		const childState = {};
		
		// body
		childState.body = {
			view
		};
		
		// pageHeader
		childState.pageHeader = {
			subttl: app.ttls.subttls[view]
		};
		
		if(flg.keyChanged) {
			if(!flg.login && contentKey && app.config.dataItems[contentKey]) {
				childState.pageHeader.ttl = app.config.dataItems[contentKey];
			} else {
				childState.pageHeader.ttl = app.ttls.pagettl;
			}
		}
		
		// sections
		this.childSections.forEach(v => {
			childState[`${v}Section`] = {
				visible: view === v,
				contentKeyChanged: flg.keyChanged
			};
		});
		
		if(view !== this.currentView) {
			flg.viewChanged = true;
			this.currentView = view;
			
			if(flg.releaseWL && view === "list" && !flg.updList) {
				// ログイン待ちからの復旧時にlistを表示する場合は、一覧を描画する
				flg.updList = true;
			}
			
		} else
		if(view === "list" && !flg.updList) {
			// list表示中の更新は一覧を再描画する（検索実行時）
			flg.updList = true;
		}
		
		// [i]
		if( u_.hasProperty(state, "i") ) {
			if(!state.i || view === "list") {
				delete state.i;
			} else {
				childState[`${view}Section`].itemId = state.i;
				
				if( !u_.isObject(app.module.items.byId) ) {
					// itemsロード前に、データのIDが指定されている場合はロードする
					await this.promise;
					this.promise = app.module.loadItemById(state.i);
				}
			}
		}
		
		
		//// history change ////
		flg.popstate || app[app.isReady ? "pushState" : "replaceState"](state);
		
		
		//// render page ////
		// フッターを隠して子Vuwを更新
		app.isReady && this.get("appFooter").$self.removeClass("fixed-bottom");
		
		// ---- async process ----
		await this.promise;
		
		if(flg.keyChanged) {
			this.get("body").$self.attr("data-content", contentKey);
			this.$window.trigger("resize", [true]);
		}
		
		// [search]
		if(flg.keyChanged || flg.popstate) {
			// contentKeyが変更された場合かpopstateの場合は初期化
			!!app.fm.search && app.fm.search.setVal( app.getFiltered(false) );
		}
		
		// [set children state]
		const methods = Object.keys(childState).map(vuwName => {
			return this.get(vuwName).setState(childState[vuwName]);
		});
		
		// [update listSection]
		flg.updList && methods.push( app.initList() );
		
		// [set scroll]
		this._scrollBase = this.get("pageHeader").$self.offset().top;
		this._scrollBase -= this.get("body").smoothScrollBuffer || 0;
		if(this.$window.scrollTop() > this._scrollBase) {
			const scrollTop = this._scrollBase;
			methods.push( new Promise(resolve => {
				$(document.scrollingElement).animate({ scrollTop }, "fast", resolve);
			}) );
		}
		
		this.promise = Promise.all(methods)
		.then(() => {
			if(app.isReady) {
				// pageMainの高さの固定を解除
				!!pageMain && pageMain.$self.css("min-height", "");
				
				// フッターを再表示
				this.get("appFooter").$self.addClass("fixed-bottom");
			}
			
			// 表示セクションの切り替え時にchangeSectionイベントをトリガー
			flg.viewChanged && this.$window.trigger("changeSection", [view]);
			
		})
		// on error
		.catch((...args) => args.forEach(err => {
			if(
				u_.isObject(err) &&
				u_.hasProperty(err, "code") &&
				isNaN(err.code)
			) {
				csl.warn(err);
			} else
			if(err) {
				console.error("on vuwer.serState()", err);
			}
		}));
		
		flg.keyChanged && this.promise.then(() => app.hideLoading("key changed"));
		
		return this.promise;
	}
};
